module.exports = __webpack_public_path__ + "static/img/jb4.1bfdc7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/jb4.png
// module id = DfHo
// module chunks = 0